import React from 'react'

import { Box, IconButton } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import CortexChatPanel from './CortexChatPanel'

// Native replacement for ConditionalRenderAssistant mode="sidebar" +
// kwik-assistant's embedded Chat, scoped to the ticket currently selected in
// kwikweb's own Chat component (frontend/src/components/Chat/index.js).
// `chat` is that ticket object (same shape passed to ChatRightSideBar),
// already carrying `uniqueid` and `chatstatus` - no window.setExternalId
// bridge needed, this is a direct prop.
const SidebarCortexAssistant = ({ chat, closeAssistant }) => {
    const canSend = !!(chat?.chatstatus && (chat.chatstatus === 'QUEUE' || chat.chatstatus === 'ONCHAT'))

    return (
        <Box display="flex" flexDirection="column" height="100%">
            <Box className="accordionHeader" display="flex" alignItems="center" onClick={closeAssistant} sx={{ cursor: 'pointer' }}>
                <IconButton className="contactHistory-iconButton">
                    <ChevronRightIcon />
                </IconButton>
                Cortex
            </Box>
            <Box flex={1} minHeight={0}>
                <CortexChatPanel
                    rawExternalId={chat?.uniqueid}
                    useTicketLock
                    canSendMessage={canSend}
                />
            </Box>
        </Box>
    )
}

export default SidebarCortexAssistant
